import React, { useEffect, useRef, useState } from 'react';

import { FormikField as Field, Input, PancakeStack, VStack, WorkflowHeader } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';
import { Form, Formik } from 'formik';

import { ChatMessage, Message, MessageDirection, fakeInitialMessages } from './components/Message';

export const AgentsPlaygroundPage: React.FC = () => {
  const [messages, updateMessages] = useState<ChatMessage[]>(fakeInitialMessages);
  const addMessage = (message: ChatMessage) => updateMessages([...messages, message]);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  useEffect(() => {
    document.body.classList.add('HideChatbot');
    return () => document.body.classList.remove('HideChatbot');
  }, []);

  return (
    <ErrorBoundary fallbackType="full" feature="agents playground" owner="agents">
      <PancakeStack css={{ maxWidth: '100%', height: '100vh' }}>
        <PancakeStack.Header
          css={{
            maxWidth: '100%',
            background: 'background.surface',
            borderBottom: '1px solid token(colors.border.weak)',
          }}
        >
          <WorkflowHeader css={{ padding: 'space.0', justifySelf: 'center' }}>
            <WorkflowHeader.Leading />
            <WorkflowHeader.Title>Agents playground</WorkflowHeader.Title>
            <WorkflowHeader.Trailing />
          </WorkflowHeader>
        </PancakeStack.Header>
        <PancakeStack.Main
          css={{
            padding: 'space.300',
            background: 'background.surface',
            display: 'flex',
            gap: 'space.300',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <VStack css={{ flex: 1, overflowY: 'auto', gap: 'space.200' }}>
            {messages.map(message => (
              <Message {...message} />
            ))}
            <div ref={messagesEndRef} />
          </VStack>
          <VStack css={{ flexShrink: 0 }}>
            <Formik
              initialValues={{ inputText: '' }}
              onSubmit={({ inputText }, { resetForm }) => {
                if (inputText.trim()) {
                  addMessage({ content: inputText, direction: MessageDirection.Outgoing });
                  resetForm();
                }
              }}
            >
              <Form>
                <Field name="inputText">
                  <Field.Control>
                    <Input alignment="left" autoFocus={true} aria-label="Input text" placeholder="Type a message..." />
                  </Field.Control>
                </Field>
              </Form>
            </Formik>
          </VStack>
        </PancakeStack.Main>
      </PancakeStack>
    </ErrorBoundary>
  );
};
